export const getCustomersUrl = () => `/customers`;
export const getCustomerProfilUrl = (customerId: string): string => {
  return `/customers/${customerId}`;
};

/** PATCH - Partial update of customer KYC (contact, address). Body: only changed fields. */
export const updateCustomerKYCUrl = (businessKey: string): string =>
  `/customers/prospect/${businessKey}`;

export const getCoreBankingSearchUrl = () => `/core_banking/search`;
export const getCoreBankingImportUrl = () => `/customers/import`;
export const getUnifiedSearchUrl = () => `/customers`;

export const getCustomerMandatesUrl = (businessKey: string): string =>
  `/customers/${businessKey}/mandates`;

export const createCustomerMandateUrl = (businessKey: string): string =>
  `/customers/${businessKey}/mandates`;

export const updateCustomerMandateUrl = (
  businessKey: string,
  mandateId: string,
): string => `/customers/${businessKey}/mandates/${mandateId}`;

export const deleteCustomerMandateUrl = (
  businessKey: string,
  mandateId: string,
  reason: string,
): string => `/customers/${businessKey}/mandates/${mandateId}?reason=${reason}`;
